import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token'); // Supondo que você armazene o token no localStorage

  // Se não houver token, redireciona para a página de login
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Se houver token, renderiza os filhos (as páginas protegidas)
  return children;
};

export default ProtectedRoute;
